import SettingsScreen from '@/screens/profile-screen/edit/SettingsScreen'

export default function SettingsScreenRoute() {
  return <SettingsScreen />
}

